var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 16 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 16 15)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 16 10)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 16 5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72069 12.7475C5.89959 12.5875 6 12.3711 6 12.1456C6 11.92 5.89959 11.7036 5.72069 11.5437L2.32043 8.47866L5.72069 5.45634C5.89959 5.29638 6 5.07999 6 4.85444C6 4.62889 5.89959 4.4125 5.72069 4.25254C5.63139 4.17252 5.52516 4.109 5.40811 4.06566C5.29106 4.02232 5.16552 4 5.03871 4C4.91191 4 4.78637 4.02232 4.66932 4.06566C4.55227 4.109 4.44604 4.17252 4.35674 4.25254L0.284121 7.87249C0.194093 7.95185 0.122636 8.04628 0.0738712 8.15032C0.0251067 8.25436 2.80548e-08 8.36595 2.80548e-08 8.47866C2.80548e-08 8.59136 0.0251067 8.70295 0.0738712 8.80699C0.122636 8.91103 0.194093 9.00546 0.284121 9.08483L4.35674 12.7475C4.44604 12.8275 4.55227 12.891 4.66932 12.9343C4.78637 12.9777 4.91191 13 5.03871 13C5.16552 13 5.29106 12.9777 5.40811 12.9343C5.52516 12.891 5.63139 12.8275 5.72069 12.7475Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClosed);
export default __webpack_public_path__ + "static/media/sidebarClosed.916daf306bafe0cd71e8cdb21a76891f.svg";
export { ForwardRef as ReactComponent };